/**
 * Neon Pack's own theme variables: the neon world's (`NEON_TOKENS`), shared with Neon Slam. The
 * glow is the pack's foil, wordmark and the world's tint; the grid its seam, emblem and card
 * edges.
 */
import { NEON_TOKENS } from "../neon/tokens";

export const NEON_PACK_TOKENS = NEON_TOKENS;
